import { currencyParser, customDateFormat } from '../misc'

export const gstInvoicesParser = invoices => {
  if (invoices?.length > 0) {
    return invoices.map(invoice => gstInvoiceParser(invoice))
  }
  return []
}

const gstInvoiceParser = invoice => {
  return {
    invoiceNumber: invoice?.invoice_number,
    grossRevenue: currencyParser(invoice?.gross_revenue_earned),
    netRevenue: currencyParser(invoice?.net_revenue_earned),
    gstPaid: currencyParser(invoice?.gst_paid_on_revenue),
    revenueDate: customDateFormat(invoice?.revenue_on),
    sgst: currencyParser(invoice?.sgst),
    cgst: currencyParser(invoice?.cgst),
    igst: currencyParser(invoice?.igst),
    invoiceDocumentId: invoice?.document_platform_revenue_invoice_id?.document_id,
  }
}
